import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
})
export class CardHeaderComponent {
  @Input() headerText: string = '';
  @Input() headerTextSuffix: string = '';
  @Input() helpPageName: string = '';
  @Input() headerId: string = '';
  @Input() headerClass: string = '';
  @Input() helpIconClass: string = '';
  @Input() showHelpIcon = true;
}
